import axios from 'axios';
import type {
  KioskRequestPayload,
  KioskResponsePayload,
  KioskResponsePayloadError,
} from './types/kiosk';
import { getKioskInstallationId } from '../util/auth';

export enum KioskCommand {
  mergeEmployeeData = 'mergeEmployeeData',
  fetchOperationalUnits = 'fetchOperationalUnits',
  fetchCompanies = 'fetchCompanies',
  fetchKioskInfo = 'fetchKioskInfo',
  resetEmployeePin = 'forgetPin',
  mergeRosterData = 'mergeRosterData',
  pullTimesheetFromServer = 'pullTimesheetFromServer',
  getTimesheetSetup = 'getTimesheetSetup',
}

export async function postKiosk<TResponse extends KioskResponsePayload>(
  command: KioskCommand,
  payload?: KioskRequestPayload
): Promise<TResponse> {
  const response = await axios.post<KioskRequestPayload, { data: TResponse }>(
    '/exec/kiosk/app',
    {
      cmd: command,
      ...payload,
    },
    {
      headers: {
        Authorization: `Kiosk ${getKioskInstallationId()}`,
      },
    }
  );

  if (isErrorResponse(response.data)) {
    throw new Error(response.data.InvalidKioskId);
  }

  return response.data;
}

function isErrorResponse(
  response: KioskResponsePayload
): response is KioskResponsePayloadError {
  return !!(response as KioskResponsePayloadError).InvalidKioskId;
}
